import React from 'react';

import { Tooltip } from 'antd';

import { EPartnerCode } from 'interfaces/IProduct';

function BlockedFieldTooltipProps(props: {
  partnerCod: EPartnerCode;
  enabled: boolean;
  children: React.ReactElement;
  title?: string;
}) {
  const { enabled, partnerCod, children, title } = props;

  if (!enabled) return children;

  const isAlumy = partnerCod === EPartnerCode.ALUMY;
  const isBlinket = partnerCod === EPartnerCode.BLINKET;

  if (!isBlinket && !isAlumy) return children;

  const app = isBlinket ? 'Eduzz Eventos' : 'Alumy';

  return (
    <Tooltip title={enabled ? (title ?? `Esta informação só pode ser alterada na configuração do produto ${app}`) : ''}>
      {children}
    </Tooltip>
  );
}

export default BlockedFieldTooltipProps;
